export function Page(a) {
  return {
    type: 'NAME_PAGE',
    payload: {
      name: a,
    },
  };
}
